/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessWeightProofVerificationResponse } from '../models/SuccessWeightProofVerificationResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WeightProofVerificationControllerService {

    /**
     * Verifies uploaded weight proof documents using AI.
     * Triggers AI analysis of the authenticated member's uploaded proof-of-weight documents (files tagged as 'prescription.proof-of-weight'). The AI checks that documents originate from a verified medical source, that the patient name and date of birth match, and that a weight measurement is readable. Extracted weight measurements are persisted and returned in the response.
     * @returns SuccessWeightProofVerificationResponse Verification completed; see 'verified' field for the outcome.
     * @throws ApiError
     */
    public static verify(): CancelablePromise<SuccessWeightProofVerificationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/care/continuation/proof-of-weight/verify',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
